import { useQuery } from '@tanstack/react-query'
import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'

export const useGetProposalById = (proposalId: string) => {
  const { getProposalById } = useVendorsApiClient()
  return useQuery({
    queryKey: ['proposal-me', proposalId],
    queryFn: () => getProposalById(proposalId),
    refetchOnWindowFocus: false,
    enabled: proposalId !== ''
  })
}
